import React, { useState } from 'react';
import { Grid, Divider, withStyles } from '@material-ui/core';
import { UsageSummary, UsageDetails, UsageGraph, SearchBy } from './components';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import { compose } from 'recompose';

const styles = (theme) => ({
  container: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.primary.main,
    padding: 10
  },
  content: {
    padding: '8px 10px',
    marginTop: 10,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  mainContent: {
    flex: 1
  },
  gridItem: {
    height: '50%',
    boxSizing: 'border-box',
    display: 'flex'
  }
});

const UsageReport = ({ classes, userData }) => {
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [usageData, setUsageData] = useState({
    usageSummary: [],
    usageGraphData: [],
    usageDetails: []
  });

  return (
    <div className={`${classes.container} customScroll`}>
      <header className={classes.header}>Usage Report</header>
      <Divider />
      <div className={classes.content}>
        <SearchBy setUsageData={setUsageData} />
        <Grid container spacing={8} className={classes.mainContent}>
          <Grid item xs={12} lg={5} className={classes.gridItem}>
            <UsageSummary
              data={usageData.usageSummary}
              setSelectedTerminal={setSelectedTerminal}
              userData={userData}
            />
          </Grid>
          <Grid item xs={12} lg={7} className={classes.gridItem}>
            <UsageGraph data={usageData.usageGraphData} selectedTerminal={selectedTerminal} />
          </Grid>
          <Grid item xs={12} className={classes.gridItem}>
            <UsageDetails
              data={usageData.usageDetails}
              selectedTerminal={selectedTerminal}
              userData={userData}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withUserProfile)(UsageReport);
